module.exports = __webpack_public_path__ + "images/emoji/stuck_out_tongue.c2dadc3d4906b05a3b07.png";